const statisticGroup = {
  displayField: 'internalName',
  name: 'StatisticGroup',
  description: '',
  fields: [
    {
      id: 'internalName',
      name: 'Internal Name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'statistics',
      name: 'Statistics',
      type: 'Array',
      localized: false,
      required: false,
      validations: [ { size: { min: 4, max: 4 } } ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'statistic' ] } ],
        linkType: 'Entry'
      }
    }
  ],
  sys: {
    id: 'statisticGroup',
    version: 8,
    updatedAt: '2023-08-01T21:40:44.104Z'
  }
};
export default statisticGroup;